<div class="h-full bg-white p-6 shadow-sm">
  <div class="flex min-h-[32px] items-center justify-between pb-[5px]">
    <h2
      class="m-0 inline-flex items-center gap-2 font-montserrat text-base font-bold uppercase"
    >
      <span
        class="material-icons-outlined h-[20px] w-[20px] shrink-0 text-[20px] leading-[20px]"
        aria-hidden="true"
        >bar_chart</span
      >
      {{ data$()?.title }}
    </h2>
    <div class="flex items-center gap-2">
      <button
        mat-icon-button
        class="opacity-60 transition-opacity duration-200 hover:opacity-80 [&_mat-icon]:text-[16px]"
        [attr.aria-label]="'Download ' + data$()?.title + ' data as Excel'"
        (click)="downloadXlsx()"
      >
        <mat-icon aria-hidden="true">file_open</mat-icon>
      </button>
      <button
        mat-icon-button
        class="opacity-60 transition-opacity duration-200 hover:opacity-80 [&_mat-icon]:text-[16px]"
        [attr.aria-label]="'Expand ' + data$()?.title + ' chart'"
        (click)="openModal()"
      >
        <mat-icon aria-hidden="true">fullscreen</mat-icon>
      </button>
    </div>
  </div>
  <div
    class="relative flex min-h-[180px] items-center justify-center rounded-lg px-[15px] py-[7.5px] text-center text-2xl font-normal"
    [attr.aria-busy]="loading"
  >
    <figure
      class="m-0 w-full [&>canvas]:min-h-full"
      [ngClass]="{ 'opacity-20 blur-[0.1rem]': loading }"
      [style.height]="chartService$.recommendedHeight$() + 'px'"
    >
      <p [id]="chartDescId" class="sr-only">{{ chartDescription$() }}</p>
      <canvas
        baseChart
        role="img"
        [attr.aria-label]="'Bar chart: ' + chartTitle$()"
        [attr.aria-describedby]="chartDescId"
        [type]="chartService$.barChartType"
        [data]="chartService$.barChartData$()"
        [options]="chartService$.barChartOptions"
        [plugins]="chartService$.barChartPlugins"
        (chartClick)="chartService$.chartClicked($event)"
      ></canvas>

      <figcaption class="sr-only">
        <h3 [id]="chartTableTitleId">{{ chartTitle$() }} data table</h3>
        <table [attr.aria-labelledby]="chartTableTitleId">
          <caption>
            {{
              chartTitle$()
            }}
            data points
          </caption>
          <thead>
            <tr>
              <th scope="col">Label</th>
              <th scope="col">{{ chartValueHeader$() }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of accessibleChartRows$(); track $index) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                <td>{{ row.value }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="2">No chart data available</td>
              </tr>
            }
          </tbody>
        </table>
      </figcaption>
    </figure>

    @if (loading) {
      <div class="absolute" role="status" aria-label="Loading chart">
        <mat-spinner [diameter]="75" aria-hidden="true"></mat-spinner>
      </div>
    }
  </div>
</div>
